module.exports = __webpack_public_path__ + "img/thumbnail_NileLechwe_m_normal.d728e9df.png";